import React from 'react';
import styled from 'styled-components'

import { useRoute } from 'lib/route-provider';
import Container from 'components/layout/Container';

const FooterContent = styled.div`
  display: flex;
  flex: 0 0 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: ${props => props.theme.paddingM};
  text-align: center;
  color: ${props => props.theme.supportText};
  
  span {
    font-size: ${props => props.theme.fontSizeXS};
    line-height: ${props => props.theme.lineHeightS};
    margin-bottom: ${props => props.theme.paddingXXS};
  }
`

const Footer = () => {
  const { getCurrentStep } = useRoute();

  const step = getCurrentStep();

  const isEcpPage = step.name === 'ECP Status';

  return (
    <footer>
      <Container>
        <FooterContent>
          {
            isEcpPage && 
              <span>*ECP is further defined in 
                <a href="https://www.ecfr.gov/current/title-17/chapter-I/part-1/subject-group-ECFR893b3e8e94c8047/section-1.3" target="_blank" rel="noopener noreferrer"> CFTC Regulation 1.3(m) </a> 
                and set forth in 
                <a href="https://www.law.cornell.edu/uscode/text/7/1a" target="_blank" rel="noopener noreferrer"> Section 1a(18) of the Commodity Exchange Act.</a>
              </span>
          }
          <span>
            LedgerX may request an Applicant to submit additional documentation at its sole discretion. If you have any questions, please email 
            <a href="mailto:support@ledgerx.com"> support@ledgerx.com</a>.
          </span>
          <span>LedgerX is a CFTC regulated exchange and clearinghouse.</span>
          <span>&copy;{new Date().getFullYear()} LedgerX LLC</span>
        </FooterContent>
      </Container>
    </footer>
  )
};

export default Footer;
